<template>
  <div class="login-vue">
    <div class="container">
      <p class="title">自造窗后台管理系统</p>
	  <div class=" node-line">
		  <span>选择节点</span>
		  <el-select v-model="node" placeholder="请选择" >
		      <el-option
		        v-for="(item,index) in nodeList"
		        :key="index"
		        :label="index"
		        :value="item">
		      </el-option>
		    </el-select>
	  </div>
      <div class="input-c">
        <el-input prefix-icon="el-icon-user-solid" v-model="obj.phone_number" placeholder="用户名" />
        <p class="error"></p>
      </div>
      <div class="input-c">
        <el-input
          type="password"
          v-model="obj.password"
          prefix-icon="el-icon-unlock"
          placeholder="密码"
        />
        <p class="error"></p>
      </div>
	  <div class="input-c check-box-line"><el-checkbox v-model="remember">记住密码</el-checkbox></div>
      <el-button class="submit" type="primary" @click="dologin">登陆</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "login",
  data() {
    return {
      obj: {
        phone_number: "",
        password: "",
      },
	  remember: false,
	  nodeList: [],
	  node: ''
    };
  },
  methods: {
	getProxyList() {
		this.$axios.get("server-address").then(res => {
		  if (res.code) {
			// for(let k in res.data) {
			// 	this.nodeList.push({
			// 		label: k,
			// 		value: res.data[k]
			// 	})
			// }
			this.nodeList = res.data
			this.node = this.nodeList[Object.keys(res.data)[0]] 
		  } else {
		    this.$message.error(res.message);
		  }
		}).catch((err) =>{
			this.$message.error(err.message);
		});
	},
    dologin() {
      this.$axios.post("admin-login", this.obj).then(res => {
        if (res.code) {
          sessionStorage.setItem("userinfo", JSON.stringify(res.data.user_info));
          sessionStorage.setItem("api_token", res.data.api_token);
		  if(this.remember) {
			  localStorage.setItem('login_info',JSON.stringify(this.obj))
		  }else{
			  localStorage.removeItem('login_info')
		  }
		  
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  watch: {
	  node(n) {
		  if(n) {
			  axios.defaults.baseURL = n
		  }
	  }
  },
  created() {
	  var login_info = localStorage.getItem('login_info')
	  if(login_info) {
		  this.remember = true
		  this.obj = {...JSON.parse(login_info)}
	  }
	  this.getProxyList()
  }
};
</script>
<style scoped>
.login-vue {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: url("../assets/img/loginbg.jpg");
}
.login-vue .container {
  background: rgba(255, 255, 255, 0.5);
  width: 300px;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
}
.login-vue .el-input {
  background-color: transparent;
  color: #fff;
  outline: #fff;
  border-color: #fff;
}
.login-vue ::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-moz-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-vue ::-moz-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-vue .title {
  font-size: 16px;
  margin-bottom: 20px;
}
.login-vue .input-c {
  margin: auto;
  width: 200px;
}
.login-vue .error {
  color: red;
  text-align: left;
  margin: 5px auto;
  font-size: 12px;
  padding-left: 30px;
  height: 20px;
}
.login-vue .submit {
  width: 200px;
}
.check-box-line{
	margin-bottom: 10px !important;
	text-align: left;
}
.node-line{
	display: flex;
	align-items: center;
	width: 200px;
	margin: 0 auto 10px;
}
.node-line>span{
	white-space: nowrap;
	color: #606266;
	margin-right: 12px;
}
</style>
